import { Box, Container, Typography } from '@mui/material'
import React from 'react'
import palette from '../../theme/palette'
import dayjs from 'dayjs';
import { useLocales } from '../../hooks/useLocales';
import { useAuth } from '../../hooks/useAuth';
import { formatDate, getCorrectDateFormat } from '../../shared/utils/DateUtils';
import { t } from 'i18next';


type IntoPageProps = {
    stableName?: string,
    startDate?: string | null,
    endDate?: string | null,
    repportName?: string | null,
}

function IntroPage({ stableName, startDate, endDate, repportName }: IntoPageProps) {
    const { currentLang } = useLocales()
    const { auth } = useAuth()

    const formatDateRange = () => {
        if (!startDate && !endDate) return null;

        const start = startDate ? dayjs(startDate) : null;
        const end = endDate ? dayjs(endDate) : null;

        let user_date_format = 'DD/MMMM/YYYY';
        try {
            user_date_format = getCorrectDateFormat(auth.default_date_format);
        } catch (error) {
            user_date_format = 'DD/MMMM/YYYY';
        }



        const formatAndCapitalize = (date: dayjs.Dayjs) =>
            formatDate(date.toISOString(), user_date_format, currentLang as any);

        let startForRange: dayjs.Dayjs;
        let endForRange: dayjs.Dayjs;

        if (start && !end) {
            startForRange = start;
            endForRange = start.endOf('month');
        } else if (!start && end) {
            startForRange = end.startOf('month');
            endForRange = end;
        } else if (start && end) {
            startForRange = start;
            endForRange = end;
        } else {
            return null;
        }

        return `${formatAndCapitalize(startForRange)} - ${formatAndCapitalize(endForRange)}`;
    };



    return (
        <>
            <Container maxWidth="xl" sx={{ pageBreakAfter: 'always' }} >
                <Box display="flex" justifyContent="flex-end" alignItems="center" flexWrap="wrap" gap={2} mb={3}>
                    <img
                        style={{ objectFit: 'contain', width: 55, height: 55, marginRight: 15 }}
                        src="/arioneo_logo_white.png"
                        alt="arioneo logo"
                    />
                </Box>
                <Box display={'flex'} flexDirection={'column'} justifyContent={'center'} alignItems={'center'} sx={{ minHeight: '700px' }} >
                    <Box display={'flex'} flexDirection={'column'} justifyContent={'center'} alignItems={'center'} sx={{ transform: 'translateY(-40px)' }} gap={5}>
                        <Typography variant='h4' color={palette.light.primary.main}>{repportName ?? t('stable:title:report')}</Typography>
                        <Typography variant='h2' color={palette.light.primary.main}>{stableName}</Typography>
                        <Typography variant='h5' color={palette.light.primary.main}>{formatDateRange()}</Typography>
                    </Box>
                </Box>
            </Container>

        </>
    )
}

export default IntroPage